import Keycloak from "keycloak-js";

const keycloakInstance = new Keycloak(
    {
      realm: 'TCE',
      url: 'https://keycloak.tcema.tc.br',
      clientId: 'sinc-folha',
    }
);


interface CallbackOneParam<T1 = void, T2 = void> {
    (param1: T1): T2;
  }
  /**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param mountAppVueCallback
 */

const Init = async (mountAppVueCallback: CallbackOneParam): Promise<void> => {
  keycloakInstance
    .init({ checkLoginIframe: false, enableLogging: true, })
    .then(function (authenticated) {
      // authenticated ? mountAppVueCallback() : alert("non authenticated");
      // console.info("keycloack auth: ", authenticated);
      mountAppVueCallback();
    })
    .catch((e) => {
      console.dir(e);
      console.log(`keycloak init exception: ${e}`);
    });
};

const LogOut = () => keycloakInstance.logout({redirectUri: process.env.REDIRECT_PATH});

const Login = async (redirectUri?:string ):Promise<boolean | undefined> => {
  await keycloakInstance.login({redirectUri: redirectUri});
  return keycloakInstance.authenticated;
}

const isAuthenticated = () => keycloakInstance.authenticated;

const UserName = (): string | undefined =>
  keycloakInstance?.tokenParsed?.preferred_username;

  const tokenParsed = (): any | undefined =>
  keycloakInstance?.tokenParsed;

const Token = (): string | undefined => keycloakInstance?.token;

const UserRoles = (): string[] | undefined => {
  if (keycloakInstance.resourceAccess === undefined) return undefined;
  return keycloakInstance.resourceAccess['siger'].roles
};

const updateToken = async (refreshLimit: number) => {
  await keycloakInstance.updateToken(refreshLimit)
}

const KeyCloakService = {
  InitApp: Init,
  CallLogin: Login,
  GetUserName: UserName,
  GetAccesToken: Token,
  CallLogOut: LogOut,
  GetUserRoles: UserRoles,
  isAuthenticated: isAuthenticated,
  setUpdateToken: updateToken,
  tokenParsed: tokenParsed
};

export default KeyCloakService;


  